import { render, staticRenderFns } from "./ShareTemplates.vue?vue&type=template&id=24192692&scoped=true"
import script from "./ShareTemplates.vue?vue&type=script&lang=js"
export * from "./ShareTemplates.vue?vue&type=script&lang=js"
import style0 from "./ShareTemplates.vue?vue&type=style&index=0&id=24192692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24192692",
  null
  
)

export default component.exports